import styles from "./NumberBadge.module.scss";

type NumberBadgeColour = "error" | "brand" | "neutral";
type NumberBadgeSize = "sm" | "md" ;
type NumberBadgeCategory = "filled" | "outlined";

interface INumberBadgeProps {
    /**
     * The optional Badge ID.
     */
    id?: string;

    /**
     * The badge color scheme.
     */
    variant?: NumberBadgeColour;

    /**
     * The size of the badge.
     */
    size?: NumberBadgeSize;

    /**
     * The category of the badge.
     */
    category?: NumberBadgeCategory;

    /**
     *  The number to display in the badge counter.
     */
    number: string;
}

const variantMapper: Record<NumberBadgeColour, string> = {
    "brand": styles.brand,
    "error": styles.error,
    "neutral": styles.neutral
} as const;

const categoryMapper: Record<NumberBadgeCategory, string> = {
    "filled": styles.filled,
    "outlined": styles.outlined
} as const;

const sizeMapper: Record<NumberBadgeSize, string> = {
    "md": styles.md,
    "sm": styles.sm
} as const;

/**
 * The number badge.
 * @param {INumberBadgeProps} param The props used to render the number badge.
 * @returns The rendered component.
 */
function NumberBadge({
    id,
    variant = "brand",
    size = "md",
    category = "filled",
    number
}: Readonly<INumberBadgeProps>): JSX.Element {
    return (
        <span
            id={id}
            className={`${styles.numberBadge} ${variantMapper[variant]} ${categoryMapper[category]} ${sizeMapper[size]}`}
        >
            {number}
        </span>
    );
}

export { INumberBadgeProps, NumberBadge };
